import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import 'rxjs-compat/add/operator/startWith';
import 'rxjs-compat/add/operator/debounceTime';
import 'rxjs-compat/add/operator/distinctUntilChanged';
import 'rxjs-compat/add/operator/switchMap';
import {ServiceModel} from '@shared/models/service.model';

@Component({
  selector: 'app-service-visit-create-popup',
  template: `
  <app-page-card-header title="SERVICE VISIT CREATE" (onBack)="dialogRef.close()">
  </app-page-card-header>
    <app-service-visit-create [isPopup]="true" [item]="data?.item" [rateType]="data?.rateType" (onCreated)="dialogRef.close(true)"></app-service-visit-create>`
})
export class ServiceVisitCreatePopupComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { item: ServiceModel, rateType: string },
    public dialogRef: MatDialogRef<ServiceVisitCreatePopupComponent>,
  ) {
  }

  ngOnInit() {
  }
}
